import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatDialog } from '@angular/material/dialog';
import { AppComponent } from 'src/app/app.component';
import { NotificationService } from 'src/app/notification.service';
import { LeadSourceService } from 'src/app/shared/services/leadsource.services';
import { TblLeadSources } from 'src/app/shared/models/leadsources';
import { ConfirmDialogComponent } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { LocalStorageService } from 'src/app/utility/localStorageService';
import { Observable } from 'rxjs';
import { EditLeadSourceDialogComponent } from './edit-lead-source-dialog.component';
import { PagerService } from 'src/app/shared/pagination';

@Component({
  selector: 'app-sources',
  templateUrl: './lead-sources.component.html',
  styleUrls: ['./lead-sources.component.css']
})
export class LeadSourcesComponent implements OnInit {
  isEditing: boolean;
  model: TblLeadSources;
  members: Observable<TblLeadSources[]>;
  allItems: TblLeadSources[] = [];
  pagedItems: TblLeadSources[] = [];
  pager: any = {};
  modalRef: BsModalRef;
  boxTitle: string;
  edit: any;
  userType: string;

  constructor(private _leadSourceService: LeadSourceService,
    private modalService: BsModalService,
    private localStorage: LocalStorageService,
    private spinnerService: AppComponent, 
    private notifyService: NotificationService,
    private dialog: MatDialog,
    private pagerService: PagerService) {
  }

  ngOnInit(): void {
    this.userType = this.localStorage.get("userType")
    this.model = new TblLeadSources();
    this.getAllData();
  }
  ngAfterViewInit() {
    //this.dt1.datetimeFormat = {"yyyy-mm-dd"};
  }
  getAllData() {
    //this.spinnerService.spinnerStatus(true);
    this.members = this._leadSourceService.getAllLeadSource();
    this.members.subscribe(data => {
      this.allItems = data || [];
      this.setPage(1);
    });
    //this.spinnerService.spinnerStatus(false);
  }
  
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.allItems.length, page, 8);
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  openAddDialog() {
    const model = new TblLeadSources();
    const dialogRef = this.dialog.open(EditLeadSourceDialogComponent, {
      width: '500px',
      data: {
        title: 'Add New Lead Source',
        model: model,
        isEditing: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.model = result.model;
        this.edit = false;
        this.create_edit();
      }
    });
  }

  openEditDialog(id: any) {
    this._leadSourceService.getLeadSourceById(id).subscribe(
      resp => {
        const dialogRef = this.dialog.open(EditLeadSourceDialogComponent, {
          width: '500px',
          data: {
            title: 'Edit Lead Source',
            model: resp,
            isEditing: true
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result && result.action === 'save') {
            this.model = result.model;
            this.edit = true;
            this.create_edit();
          }
        });
      }
    );
  }
  deleteData(id: any) {
    let modalConfig: any = { animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false };
    const initialState = { mode: 'Delete', module: 'Lead Source', refNo: id };
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, modalConfig, { class: 'modal-sm', initialState }))
  }

  //Editing Data
  validateForm(): boolean {
    // if(!this.model.name){
    //   this.notifyService.showError("Name can not be empty!", "Error");
    //   return false;
    // }
    // else 
    if (!this.model.sourceType) {
      this.notifyService.showError("Email ID can not be empty!", "Error");
      return false;
    }
    else {
      return true;
    }
  }

  create_edit() {

    if (!this.validateForm()) {
      return;
    }
    if (this.edit) {
      this._leadSourceService.saveAndUpdateLeadSource(this.model).subscribe(resp => {
        if (resp.refNo > 0) {
          this.notifyService.showSuccess("Updated Successfully!", "Success");
          this.getAllData()
        }
        else {
          this.notifyService.showError(resp.message, "Error")
        }
      });
    }
    else {
      this._leadSourceService.saveAndUpdateLeadSource(this.model).subscribe(resp => {
        if (resp.refNo > 0) {
          this.notifyService.showSuccess("Saved Successfully!", "Success");
          this.getAllData()
        }
        else {
          this.notifyService.showError(resp.message, "Error")
        }
      }, (err) => {
        this.notifyService.showError(err, "Error")
      });
    }
  }
  close_clicked() {
    this.getAllData();
  }
  stopPropagation(event) {
    event.stopPropagation();
  }
  searchTable() {
    var term, table;
    term = document.getElementById("myInput") as unknown as HTMLInputElement
    // get term to search
    term = term.value.toLowerCase();
    table = document.getElementById("myTable") as HTMLTableElement
    // get table rows, handle as array.
    table = Array.from(table.rows);

    // filter non-matching rows; these are set to display='none'
    table.filter(function (el) {
      return el.textContent.toLowerCase().indexOf(term) ==
        -1
    }).map(x => x.style.display = "none");

    // filter matching rows; these are set to display =''
    table.filter(function (el) {
      return el.textContent.toLowerCase().indexOf(term) > -1
    }).map(x => x.style.display = "");
  }
}
